import * as React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../button";

/** 간단한 className 머지 */
function cn(...xs: Array<string | false | undefined>) {
  return xs.filter(Boolean).join(" ");
}

/** 스크롤 내려가면 elevation 주기 */
function useElevatedOnScroll(threshold = 2) {
  const [elevated, setElevated] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setElevated(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return elevated;
}

type AppBarProps = {
  title?: string;
  backButton?: boolean;
  closeButton?: boolean;
  transparent?: boolean;
  /** transparent 하단 그라데이션 보더 숨김 */
  hideBottomBorder?: boolean;
  right?: React.ReactNode;
  height?: number;
  className?: string;
  onBack?: () => void;
};

export default function AppBar({
  title,
  backButton = true,
  closeButton = false,
  transparent = false,
  hideBottomBorder = false,
  right,
  height = 56,
  className,
  onBack,
}: AppBarProps) {
  const navigate = useNavigate();
  const elevated = useElevatedOnScroll(2);

  const handleBack = () => {
    if (onBack) return onBack();
    if (history.length > 1) navigate(-1);
    else window.location.assign("/");
  };

  return (
    <header
      className={cn(
        "sticky top-0 z-40",
        transparent ? "border-transparent" : "bg-white/90 backdrop-blur",
        !transparent && (elevated ? "shadow-sm" : "shadow-none"),
        className
      )}
      // iOS 노치 대응: 안전하게 safe-area 상단 패딩 더해줌
      style={{
        paddingTop: "var(--safe-area-inset-top)",
      }}
    >
      <div
        className="w-full flex flex-row-between"
        style={{
          height: height
        }}
      >
        {/* Left */}
        <div className="flex-1 flex items-center pl-4"
          onClick={() => backButton && handleBack()}
        >
          {backButton ? (
            <button
              aria-label="뒤로가기"
              className="rounded-xl grid"
            >
              {/* 아이콘 없이 텍스트/유니코드로도 간단히 */}
              <img className="w-[20px] h-[20px]" src="/icons/ic-back.webp" />
            </button>
          ) : null}
        </div>

        {/* Center Title */}
        <div className="flex">
          {title ? (
            <h1 className="text-[16px] font-bold text-black text-center">
              {title}
            </h1>
          ) : null}
        </div>


        {/* Right actions */}
        <div className="flex-1 flex items-center justify-end pr-4">
          {right ? right : closeButton ? (
            <Button
              className="p-0"
              label=""
              onClick={onBack}
            >
              <img className="w-[20px] h-[20px]" src="/icons/ic-close.webp" />
            </Button>

          ) : (<div />)}
        </div>
      </div>
      {/* safe bottom border gradient for transparent bars if needed */}
      {transparent && !hideBottomBorder ? <div className="h-px bg-gradient-to-r from-black/10 to-transparent" /> : null}
    </header>
  );
}